import { $Item } from "../types";
import { $YouTubeItem } from "./types";

export default function userShare(item: $Item): Promise<ShareData> {
  return new Promise((resolve) => {
    const _item = item as $YouTubeItem;
    resolve({ text: _item.youTubeId });
  });
}
